module.exports = "/_next/static/images/13b8b9bfe113ec37724891ebb3015b40-robot-xs.png";